import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';

import { Col, Grid, Row, FormGroup } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchSubstances } from "../../../../redux/actions/substance";
import {getAllProducts, getProducts, setAutocompleteProducts} from "../../../../redux/actions/product";
import ProductGeneralAutosuggest from "../../../../app-components/Products/ProductGeneralAutosuggest/ProductGeneralAutosuggest.jsx";
import TrackingService from '../../../../services/TrackingService';

class NomForm extends React.Component {

    constructor(props) {
        super(props);
        
        this.props.fetchSubstances();
        this.props.getAllProducts();
        this.state = {
            nom: '',
        }
        
        this.debounceGetProducts = _.debounce((filters) => this.props.getProducts(filters, true), 1000);
        this.lastResultStatus = null;
    }

    componentDidUpdate(prevProps) {
        // Track when analysis result changes (indicating a new analysis was performed)
        if (prevProps.result !== this.props.result && this.props.result.status !== null) {
            this.trackAnalysisResult();
        }
    }

    trackAnalysisResult = async () => {
        try {
            const isCI = this.props.result.status === 1;
            const analysisId = await TrackingService.trackAnalysis({
                analysisType: 'CONTRAINDICATION',
                medications: [],
                findingsCount: isCI ? 1 : 0,
                findings: [],
                riskLevel: isCI ? 'HIGH' : 'LOW',
                patientContext: {},
                responseTime: 0,
                cacheHit: false
            });
            if (analysisId) {
                await TrackingService.trackSave(analysisId, {
                    name: 'Analyse nom commercial',
                    notes: 'Analyse de contre-indication médicament-substance'
                });
                await TrackingService.trackConsultation(analysisId, 5);
            }
        } catch (e) {}
    };

    setValue(val, index) {
        let newState = {};
        newState[index] = val;
        this.setState(newState);
    }

    chooseStatus(status) {
        switch (status) {
            case null:
                return {bg: "#F5F5F5", col: '#536878' };
            case 0:
                return {bg: "#FFF5FE", col: '#DC143C' };
            case 1:
                return {bg: "#FEFEFA", col: '#FF7E00' };
            case -1:
                return {bg: "#FEFEFA", col: '#03C03C' };
            default:
                return {bg: "#F5F5F5", col: '#536878' };
        }
    }

    customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '50px',
            borderColor: state.isFocused ? '#1DC7EA' : base.borderColor,
            boxShadow: state.isFocused ? '0 0 0 1px #1DC7EA' : base.boxShadow,
            '&:hover': {
                borderColor: '#1DC7EA'
            }
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: '14px'
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#1DC7EA' : state.isFocused ? '#F4F9FE' : base.backgroundColor,
            color: state.isSelected ? 'white' : base.color,
            '&:active': {
                backgroundColor: '#1DC7EA'
            }
        })
    };

    getAlternativesAPURMED = () => {
        // Récupérer le produit sélectionné
        const produit = this.props.products.find(
            p => p.nom && p.nom.toLowerCase() === (this.state.nom || '').toLowerCase()
        );
        if (!produit) return [];
        // Récupérer la substance sélectionnée
        const substance = this.props.substances.find(
            s => s._id === (this.props.substanceSelected?._id || this.props.substanceSelected?.value)
        );
        // Profil = nom de la substance
        const profil = substance ? substance.name : null;
        if (!profil) return [];
        // Famille et classe du produit à remplacer
        const famille = produit.familleTherapeutique || produit.famille || '';
        const classe = produit.classesPharmacologiques || produit.classePharmacologique || '';
        // Alternatives de la même famille et classe, non contre-indiquées dans ce profil
        const memeClasse = this.props.products.filter(med =>
            med.nom !== produit.nom &&
            (med.familleTherapeutique || med.famille) === famille &&
            (med.classesPharmacologiques || med.classePharmacologique) === classe &&
            (!med.profilsContreIndiques || !med.profilsContreIndiques.includes(profil))
        );
        // Alternatives autres classes de la même famille
        const autreClasse = this.props.products.filter(med =>
            med.nom !== produit.nom &&
            (med.familleTherapeutique || med.famille) === famille &&
            (med.classesPharmacologiques || med.classePharmacologique) !== classe &&
            (!med.profilsContreIndiques || !med.profilsContreIndiques.includes(profil))
        );
        return { famille, classe, memeClasse, autreClasse };
    }

    render() {
        const isContreIndique = this.props.result.status === 0;
        const alternatives = isContreIndique ? this.getAlternativesAPURMED() : null;
        return (
            <div className="main-content" >
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content={
                                    <Grid fluid>
                                        <h3 style={{color:'black', fontSize:'30px'}} className="text-center">
                                            <strong>Veuillez renseigner les informations nécessaires pour l'analyse d'interactions médicamenteuses contre-indiquées !</strong>
                                        </h3>
                                        <Row>
                                            <Col xs={12} sm={6} md={6}>
                                                <FormGroup>
                                                    <label>Substance</label>
                                                    <Select
                                                        options={this.props.substances
                                                            .sort((a, b) => a.name.localeCompare(b.name))
                                                            .map(substance => ({
                                                                label: substance.name,
                                                                value: substance._id,
                                                                nomsCommerciauxContreIndiquees: substance.nomsCommerciauxContreIndiquees
                                                            }))
                                                        }
                                                        placeholder="Rechercher une substance..."
                                                        onChange={this.props.onChangeSubstance}
                                                        styles={this.customStyles}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        noOptionsMessage={() => "Aucune substance trouvée"}
                                                        formatOptionLabel={option => (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ marginRight: '10px' }}>
                                                                    <i className="fa fa-flask" />
                                                                </span>
                                                                {option.label}
                                                            </div>
                                                        )}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={12} sm={6} md={6}>
                                                <FormGroup>
                                                    <label>Nom commercial</label>
                                                    <ProductGeneralAutosuggest
                                                        value={this.state.nom}
                                                        onChange={(e) => this.setValue(e.target.value, 'nom')}
                                                        addTag={(val) => {
                                                            this.props.onChangeProduct({ label: val, value: val });
                                                            this.setState({'nom': val});
                                                        }}
                                                        suggestions={this.props.autocompleteProducts}
                                                        placeholder="Rechercher un médicament..."
                                                        clearSuggestions={() => this.props.setAutocompleteProducts([])}
                                                        getSuggestions={(val) =>
                                                            this.debounceGetProducts({
                                                                nom: val,
                                                                DCI: '',
                                                                familleTherapeutique: '',
                                                                classesPharmacologiques: '',
                                                                dosage: '',
                                                                forme: ''
                                                            })
                                                        }
                                                        style={{
                                                            width: '100%',
                                                            minHeight: '50px',
                                                            borderRadius: '4px'
                                                        }}
                                                        formControl
                                                        nameColumn="nom"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content={
                                    <div className="text-center"
                                         style={{
                                             height: '100%',
                                             backgroundColor: this.chooseStatus(this.props.result.status).bg,
                                             padding: '20px',
                                             borderRadius: '8px'
                                         }}>
                                        <p className="text-center"
                                           style={{
                                               paddingTop: '5%',
                                               fontSize: '30px',
                                               color: this.chooseStatus(this.props.result.status).col
                                           }}>
                                            {this.props.result.data}
                                        </p>
                                        {isContreIndique && alternatives && (
                                            <div style={{marginTop: 30, textAlign: 'left'}}>
                                                <h4>Alternatives thérapeutiques possibles&nbsp;:</h4>
                                                <div style={{marginBottom: 10}}>
                                                    <b>Famille thérapeutique&nbsp;:</b> {alternatives.famille || 'Non spécifiée'}<br/>
                                                    <b>Classe pharmacologique&nbsp;:</b> {alternatives.classe || 'Non spécifiée'}
                                                </div>
                                                <div>
                                                    <b>Même classe&nbsp;:</b>
                                                    <ul>
                                                        {alternatives.memeClasse.length > 0 ? alternatives.memeClasse.map((med, idx) => (
                                                            <li key={idx}>{med.nom} {med.dci ? `(DCI: ${med.dci})` : ''}</li>
                                                        )) : <li>Aucune alternative trouvée</li>}
                                                    </ul>
                                                </div>
                                                <div>
                                                    <b>Autres classes de la même famille&nbsp;:</b>
                                                    <ul>
                                                        {alternatives.autreClasse.length > 0 ? alternatives.autreClasse.map((med, idx) => (
                                                            <li key={idx}>{med.nom} {med.dci ? `(DCI: ${med.dci})` : ''}</li>
                                                        )) : <li>Aucune alternative trouvée</li>}
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <div className="text-center" style={{ marginTop: '20px' }}>
                        <Button
                            bsStyle="info"
                            fill
                            type="submit"
                            style={{
                                fontSize: "1.6rem",
                                borderRadius: "20px",
                                padding: "10px 30px",
                                transition: "all 0.3s ease"
                            }}
                        >
                            <i className="fa fa-search-plus" style={{ marginRight: '10px' }} />
                            Lancer l'analyse
                        </Button>
                    </div>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        substances: state.substances.substances,
        products: state.products.products,
        loading: state.status.loading,
        autocompleteProducts: state.products.autocompleteProducts
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchSubstances: filter => {
            dispatch(fetchSubstances(filter));
        },
        getAllProducts: filter => {
            dispatch(getAllProducts(filter));
        },
        getProducts: (filter, autocomplete) => {
            dispatch(getProducts(filter, autocomplete));
        },
        setAutocompleteProducts: products => {
            dispatch(setAutocompleteProducts(products));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NomForm);
